/**
 * CWSN (Children With Special Needs) category config
 *
 * KPIs: teacherForPrimary, teacherForSecondary,
 *       studentInPrimary, studentInSecondary
 */
import type { CategoryConfig } from './CategoryConfig';

export const cwsnConfig: CategoryConfig = {
  categoryKey: 'cwsnProfile',
  label: 'CWSN',
  priority: 5,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName',
      'teacherForPrimary', 'teacherForSecondary',
      'studentInPrimary', 'studentInSecondary',
    ],
  },
};
